export const polyfills = {
  initialize () {
    console.log('DEBUG (polyfills) Initializing polyfills.')

    // try {
    //   if (!Array.prototype.forEach) {
    //     console.log('DEBUG (polyfills.initialize) Initializing Array.forEach polyfill.')
    //     require('polyfills/Array.forEach')
    //   }
    // } catch (error) {
    //   console.log('!!! ERROR (polyfills.initialize) Error encountered during Array.includes polyfill initialization.')
    //   console.log(error)
    //   MK.captureException(error)
    // }

    // try {
    //   if (!Array.prototype.includes) {
    //     console.log('DEBUG (polyfills.initialize) Initializing Array.includes polyfill.')
    //     require('polyfills/Array.includes')
    //   }

    // } catch (error) {
    //   console.log('!!! ERROR (polyfills.initialize) Error encountered during Array.includes polyfill initialization.')
    //   console.log(error)
    //   MK.captureException(error)
    // }

    // try {
    //   console.log('DEBUG (polyfills.initialize) Initializing DOM4 polyfill.')
    //   require('polyfills/dom4')
    // } catch (error) {
    //   console.log('!!! ERROR (polyfills.initialize) Error encountered during DOM4 polyfill initialization.')
    //   console.log(error)
    //   MK.captureException(error)
    // }

    try {
      console.log('DEBUG (polyfills.initialize) Initializing browser detection.')
      require('polyfills/browserDetection').browserDetection.initialize()
    } catch (error) {
      console.log('!!! ERROR (polyfills.initialize) Error encountered during browser detection bundle initialization.')
      console.log(error)
      MK.captureException(error)
    }

    // try {
    //   // console.log('DEBUG (polyfills.initialize) Initializing dataset polyfill.')
    //   require('polyfills/dataset')
    // } catch (error) {
    //   console.log('!!! ERROR (polyfills.initialize) Error encountered during dataset polyfill initialization.')
    //   console.log(error)
    //   MK.captureException(error)
    // }

    // try {
    //   // console.log('DEBUG (polyfills.initialize) Initializing matchmedia polyfill.')
    //   require('polyfills/matchMedia')
    // } catch (error) {
    //   console.log('!!! ERROR (polyfills.initialize) Error encountered during matchMedia polyfill initialization.')
    //   console.log(error)
    //   MK.captureException(error)
    // }
  }
}
